<template>
  <main class="form-signin">
    <form class="w-100">
      <h1 class="h3 mb-3 fw-normal">请登录</h1>

      <div class="input-group my-1">
        <span class="input-group-text" id="inputGroupPrepend">
          <i class="bi-person"></i>
        </span>
        <input v-model="form.agentKey" ref="agentKey" type="account" class="form-control" id="floatingInput" required
          :disabled="submitDisabled" placeholder="账号*" />
      </div>
      <div class="input-group my-1">
        <span class="input-group-text" id="inputGroupPrepend">
          <i class="bi-key"></i>
        </span>
        <input v-model="form.passwd" type="password" ref="passwd" class="form-control mb-0" id="floatingPassword"
          required :disabled="submitDisabled" placeholder="密码*" />
      </div>
      <div class="input-group my-1">
        <span class="input-group-text" id="inputGroupPrepend">
          <i class="bi-whatsapp"></i>
        </span>
        <select v-model="form.loginType" class="form-control form-select" id="loginType" required
          :disabled="submitDisabled" placeholder="登录类型">
          <option value="" select disabled>请选择登录类型*</option>
          <option :value="1">sip号</option>
          <option :value="2">webrtc</option>
          <option :value="3">手机号</option>
        </select>
      </div>
      <div class="input-group my-1">
        <span class="input-group-text" id="inputGroupPrepend">
          <i class="bi-files"></i>
        </span>
        <select v-model="form.workType" class="form-control form-select" :disabled="submitDisabled" aria-label="工作方式">
          <option value="" select disabled>工作方式</option>
          <option :value="1">普通</option>
          <option :value="2">预测</option>
        </select>
      </div>

      <button class="mt-3 w-100 btn btn-lg btn-primary" type="submit" :disabled="submitDisabled"
        @click.stop.prevent="loginFun">登 录</button>
    </form>

    <!-- 验证码区域 -->
    <div v-show="showSlider" class="slider" id="slider">
      <div class="content">
        <div class="bg-img-div">
          <img id="bg-img" src="" alt />
        </div>
        <div class="slider-img-div" id="slider-img-div">
          <img id="slider-img" src="" alt />
        </div>
      </div>
      <div class="slider-move">
        <div class="slider-move-track">
          拖动滑块完成拼图
        </div>
        <div class="slider-move-btn" id="slider-move-btn"></div>
      </div>
      <div class="bottom">
        <div class="close-btn" id="slider-close-btn"></div>
        <div class="refresh-btn" id="slider-refresh-btn"></div>
      </div>
    </div>
  </main>
</template>

<script>
  import sha256 from 'sha256'

  export default {
    name: 'LoginPage',
    props: {
      loginData: {
        type: Object,
        default: () => {},
      },
    },
    created() {
      let host = `${window.location.origin}`
      if (host.includes('localhost')) {
        host = 'https://dev.voice9.com'
      }
      this.host = host

    },
    mounted() {
      this.bindSliderFunction()
    },
    data() {
      return {
        host: 'https://dev.voice9.com',
        form: {
          agentKey: '', // 账号
          passwd: '', // 密码
          loginType: 2, // 1:sip号 2:webrtc 3:手机号
          workType: 1, // 1:普通 2:预测
        },
        captchaConfig: {
          startTime: 0,
          trackArr: [],
          movePercent: 0,
          bgImageWidth: 0,
          bgImageHeight: 0,
          sliderImageWidth: 0,
          sliderImageHeight: 0,
          end: 0,
          captchaId: '',
        },
        showSlider: false, // 是否显示验证码
        submitDisabled: false,
      }
    },
    methods: {
      loginFun() {
        if (!this.form.agentKey) {
          this.$toast.open({
            message: '请输入账号',
            type: 'warning',
            position: 'bottom',
          })
          this.$refs.agentKey.focus()
          return
        }
        if (!this.form.passwd) {
          this.$toast.open({
            message: '请输入密码',
            type: 'warning',
            position: 'bottom',
          })
          this.$refs.passwd.focus()
          return
        }
        this.submitDisabled = true
        this.requestCaptcha().then(() => {
          this.showSlider = true
        }).catch(() => {
          this.submitDisabled = false
        })
      },

      // 获取验证码，返回Promise，图片加载完成后resolve
      requestCaptcha() {
        return new Promise((resolve, reject) => {
          this.axios
            .get(`${this.host}/fs-api/index/captcha`)
            .then((res) => {
              let data = res.data.data
              let sliderMoveBtn = document.getElementById('slider-move-btn')
              let sliderImgDiv = document.getElementById('slider-img-div')
              sliderMoveBtn.setAttribute('background-position', '-5px 11.79625%')

              sliderMoveBtn.style.transform = `translateX(0px)`
              sliderImgDiv.style.transform = `translateX(0px)`

              this.captchaConfig.captchaId = data['id']
              const bgImg = document.getElementById('bg-img')
              const sliderImg = document.getElementById('slider-img')

              let loaded = 0
              const checkAllLoaded = () => {
                loaded++
                if (loaded >= 2) resolve()
              }

              bgImg.onload = checkAllLoaded
              bgImg.onerror = () => reject('背景图加载失败')
              sliderImg.onload = checkAllLoaded
              sliderImg.onerror = () => reject('滑块图加载失败')

              bgImg.setAttribute('src', data.backgroundImage)
              sliderImg.setAttribute('src', data.templateImage)
            })
            .catch((e) => {
              this.$toast.open({
                message: `请求出错:${e}`,
                type: 'warning',
                position: 'bottom',
              })
              reject(e)
            })
        })
      },
      // 绑定验证码事件
      bindSliderFunction() {
        let slider = document.getElementById('slider')
        let sliderMoveBtn = document.getElementById('slider-move-btn')
        let sliderCloseBtn = document.getElementById('slider-close-btn')
        let sliderRefreshBtn = document.getElementById('slider-refresh-btn')

        slider.addEventListener('touchmove', this.clearPreventDefault, false)
        sliderMoveBtn.addEventListener('mousedown', this.down)
        sliderMoveBtn.addEventListener('touchstart', this.down)
        sliderCloseBtn.addEventListener('click', this.closeFun)
        sliderRefreshBtn.addEventListener('click', this.requestCaptcha)
      },
      closeFun() {
        this.showSlider = false
        this.submitDisabled = false
      },
      clearPreventDefault(event) {
        if (event.preventDefault) {
          event.preventDefault()
        }
      },
      initConfig(
        bgImageWidth,
        bgImageHeight,
        sliderImageWidth,
        sliderImageHeight,
        end
      ) {
        this.captchaConfig = {
          ...this.captchaConfig,
          startTime: new Date(),
          trackArr: [],
          movePercent: 0,
          bgImageWidth,
          bgImageHeight,
          sliderImageWidth,
          sliderImageHeight,
          end,
        }
      },
      down(event) {
        const bgImg = document.getElementById('bg-img')
        const sliderImg = document.getElementById('slider-img')
        this.initConfig(
          bgImg.offsetWidth,
          bgImg.offsetHeight,
          sliderImg.offsetWidth,
          sliderImg.offsetHeight,
          206
        )
        let sliderMoveBtn = document.getElementById('slider-move-btn')
        let targetTouches = event.originalEvent ?
          event.originalEvent.targetTouches :
          event.targetTouches

        let startX = event.pageX
        let startY = event.pageY
        if (startX === undefined) {
          startX = Math.round(targetTouches[0].pageX)
          startY = Math.round(targetTouches[0].pageY)
        }
        this.captchaConfig.startX = startX
        this.captchaConfig.startY = startY

        const pageX = this.captchaConfig.startX
        const pageY = this.captchaConfig.startY
        const startTime = this.captchaConfig.startTime
        this.captchaConfig.trackArr.push({
          x: pageX - startX,
          y: pageY - startY,
          type: 'down',
          t: new Date().getTime() - startTime.getTime(),
        })
        // pc
        window.addEventListener('mousemove', this.move)
        window.addEventListener('mouseup', this.up)
        // 手机端
        window.addEventListener('touchmove', this.move, false)
        window.addEventListener('touchend', this.up, false)

        sliderMoveBtn.setAttribute('background-position', '-5px 31.0092%')
      },
      move(event) {
        let sliderMoveBtn = document.getElementById('slider-move-btn')
        let sliderImgDiv = document.getElementById('slider-img-div')
        if (event.touches) {
          event = event.touches[0]
        }
        let pageX = Math.round(event.pageX)
        let pageY = Math.round(event.pageY)
        const startX = this.captchaConfig.startX
        const startY = this.captchaConfig.startY
        const startTime = this.captchaConfig.startTime
        const end = this.captchaConfig.end
        const bgImageWidth = this.captchaConfig.bgImageWidth
        let moveX = pageX - startX
        const track = {
          x: pageX - startX,
          y: pageY - startY,
          type: 'move',
          t: new Date().getTime() - startTime.getTime(),
        }
        this.captchaConfig.trackArr.push(track)
        if (moveX < 0) {
          moveX = 0
        } else if (moveX > end) {
          moveX = end
        }
        this.captchaConfig.moveX = moveX
        this.captchaConfig.movePercent = moveX / bgImageWidth

        sliderMoveBtn.style.transform = `translate(${moveX}px, 0px)`
        sliderImgDiv.style.transform = `translate(${moveX}px, 0px)`
      },
      up(event) {
        window.removeEventListener('mousemove', this.move)
        window.removeEventListener('mouseup', this.up)
        window.removeEventListener('touchmove', this.move)
        window.removeEventListener('touchend', this.up)
        if (event.changedTouches) {
          event = event.changedTouches[0]
        }
        this.captchaConfig.stopTime = new Date()
        let pageX = Math.round(event.pageX)
        let pageY = Math.round(event.pageY)
        const startX = this.captchaConfig.startX
        const startY = this.captchaConfig.startY
        const startTime = this.captchaConfig.startTime

        const track = {
          x: pageX - startX,
          y: pageY - startY,
          type: 'up',
          t: new Date().getTime() - startTime.getTime(),
        }
        this.captchaConfig.trackArr.push(track)
        this.agentLogin()
      },
      agentLogin() {
        let captchaConfig = this.captchaConfig
        let params = {
          bgImageWidth: captchaConfig.bgImageWidth,
          bgImageHeight: captchaConfig.bgImageHeight,
          sliderImageWidth: captchaConfig.sliderImageWidth,
          sliderImageHeight: captchaConfig.sliderImageHeight,
          startSlidingTime: captchaConfig.startTime,
          endSlidingTime: captchaConfig.stopTime,
          trackList: captchaConfig.trackArr,
          captchaId: captchaConfig.captchaId,
          agentKey: this.form.agentKey,
          passwd: sha256(this.form.passwd),
          loginType: this.form.loginType,
          workType: this.form.workType,
        }
        this.axios
          .post(`${this.host}/fs-api/index/login`, params)
          .then((res) => {
            if (res.data.code === 0) {
              this.$toast.open({
                message: '登录成功',
                type: 'success',
                position: 'bottom',
              })
              this.showSlider = false
              this.submitDisabled = false

              let resData = res.data.data
              let loginData = {
                ...resData,
                token: resData.token,
                agentCode: resData.agentCode,
                sipPwd: resData.sipPwd,
                sipServer: resData.sipServer,
                webrtcServer: resData.webrtcServer,
                wsServer: resData.wsServer
              }
              this.$emit('update:loginData', loginData)
              sessionStorage.setItem('loginData', JSON.stringify(loginData))
              return
            }

            // 验证码错误（1108），刷新验证码，保持滑块面板打开
            if (res.data.code === 1108) {
              this.requestCaptcha()
              return
            }
            // 其他账号错误
            this.$toast.open({
              message: res.data.message,
              type: 'error',
              position: 'bottom',
            })

            this.showSlider = false
            this.submitDisabled = false
          })
          .catch(() => {
            this.$toast.open({
              message: '请求失败，请稍后再试',
              type: 'error',
              position: 'bottom',
            })
          })
      },
    },
  }
</script>

// 内容样式
<style scoped>
  html,
  body {
    height: 100%;
  }

  body {
    display: flex;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
  }

  .form-signin {
    width: 100%;
    max-width: 430px;
    padding: 15px;
    margin: auto;
  }

  .form-signin .checkbox {
    font-weight: 400;
  }

  .form-signin .form-floating:focus-within {
    z-index: 2;
  }

  .form-signin input[type='email'] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .form-signin input[type='password'] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .btn:disabled {
    background-color: #888;
  }
</style>

// 验证码样式
<style scoped>
  #connect-container {
    float: left;
    width: 500px;
  }

  #connect-container div {
    padding: 5px;
  }

  #console-container {
    float: left;
    margin-left: 100px;
    width: 400px;
  }

  #console {
    border: 1px solid #cccccc;
    border-right-color: #999999;
    border-bottom-color: #999999;
    height: 380px;
    width: 900px;
    overflow-y: scroll;
    padding: 5px;
  }

  #console p {
    padding: 0;
    margin: 0;
  }

  .slider {
    position: absolute;
    top: 30px;
    left: 50%;
    margin-left: -140px;
    background-color: #fff;
    width: 260px;
    height: 285px;
    z-index: 999;
    box-sizing: border-box;
    padding: 9px;
    border-radius: 6px;
    box-shadow: 0 0 11px 0 #999999;
  }

  .slider .content {
    width: 100%;
    height: 159px;
    position: relative;
  }

  .bg-img-div {
    width: 100%;
    height: 100%;
    position: absolute;
    transform: translate(0px, 0px);
  }

  .slider-img-div {
    height: 100%;
    position: absolute;
    transform: translate(0px, 0px);
  }

  .bg-img-div img {
    width: 100%;
    height: 100%;
  }

  .slider-img-div img {
    height: 100%;
  }

  .slider .slider-move {
    height: 60px;
    width: 100%;
    margin: 11px 0;
    position: relative;
  }

  .slider .bottom {
    height: 19px;
    width: 100%;
  }

  .refresh-btn,
  .close-btn,
  .slider-move-track,
  .slider-move-btn {
    background: url('../assets/img/sprite.png') no-repeat;
  }

  .refresh-btn,
  .close-btn {
    display: inline-block;
  }

  .slider-move .slider-move-track {
    line-height: 38px;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    color: #88949d;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .slider {
    user-select: none;
  }

  .slider-move .slider-move-btn {
    transform: translate(0px, 0px);
    background-position: -5px 11.79625%;
    position: absolute;
    top: -12px;
    left: 0;
    width: 66px;
    height: 66px;
  }

  .slider-move-btn:hover,
  .close-btn:hover,
  .refresh-btn:hover {
    cursor: pointer;
  }

  .bottom .close-btn {
    width: 20px;
    height: 20px;
    background-position: 0 44.86874%;
  }

  .bottom .refresh-btn {
    width: 20px;
    height: 20px;
    background-position: 0 81.38425%;
  }

  #slider-close-btn {
    margin-right: 10px;
  }
</style>